export const foodInfo = {
  dog: [
    {
      food: { nl: 'Appel, appels, appelen', en: 'Apple, apples' },
      emoji: '🍏, 🍎',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan een appel geven aan je hond, maar met mate. Haal de pitten eruit, want deze bevatten cyanide. <br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-honden-appels/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give apple to your dog but only in a healthy amount. Make sure to take out the pits as they contain cyanide.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-apples/">here</a>.'
      }
    },
    {
      food: { nl: 'Peer, peren, peers', en: 'Pear, pears' },
      emoji: '🍐',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan een peer geven aan je hond, maar met mate. Haal de pitten eruit, want deze bevatten cyanide.',
        en: 'Yes, you can give pear to your dog but only in a healthy amount. Make sure to take out the pits as they contain cyanide.'
      }
    },
    {
      food: { nl: 'Blauwe bessen, bessen, blauwe bes, blauwebes, blauwebessen', en: 'Blueberries, blueberry, blue berry, blue berries' },
      emoji: '🫐',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan blauwe bessen geven aan je hond, maar met mate.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-honden-blauwe-bessen/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give blueberries to your dog but only in a healthy amount.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-blueberries-are-they-healthy-for-dogs/">here</a>.'
      }
    },
    {
      food: { nl: 'Aardbei, aarbeien', en: 'Strawberries, strawberry' },
      emoji: '🍓',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan aardbeien geven aan je hond, maar hou je vast aan een bepaalde maximum hoeveelheid.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-honden-aardbeien/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give strawberries to your dog but only in a healthy amount.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-strawberries/">here</a>.'
      }
    },
    {
      food: { nl: 'Banaan, bananen', en: 'Banana, bananas' },
      emoji: '🍌',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan banaan geven aan je hond, maar met mate.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-banaan-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give banana to your dog but only in a healthy amount.<br /><br />For more details on giving banana to your dog, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-bananas/">here</a>.'
      }
    },
    {
      food: { nl: "Mango, mango's, mangos", en: 'Mango, mangos, mangoes' },
      emoji: '🥭',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan mango geven aan je hond, maar met mate. Haal de pit eruit, want deze bevat cyanide.',
        en: 'Yes, you can give mango to your dog but only in a healthy amount. Make sure to take out the pit as it contains cyanide and can pose a choking hazard.'
      }
    },
    {
      food: { nl: 'Abrikoos, abrikozen, abrikosen', en: 'Apricot, Apricots' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan abrikoos geven aan je hond, maar met mate. Haal de pit eruit, want deze bevat cyanide.',
        en: 'Yes, you can give apricot to your dog but only in a healthy amount. Make sure to take out the pit as it contains cyanide and can cause dangerous intestinal blockages.'
      }
    },
    {
      food: {
        nl: 'Meloen, meloenen, meloens, watermeloen, water meloen, watermeloenen, cantaloupe, cantaloupen',
        en: 'Cantaloupe, Cantaloupes, honeydew, melon, melons'
      },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan meloen geven aan je hond, maar met mate. Haal de pitten eruit, want deze bevat cyanide en vergeet niet de meloen te schillen.',
        en: 'Yes, you can give cantaloupe to your dog but only in a healthy amount. Make sure to peel it and take out the pits as they contain cyanide.'
      }
    },
    {
      food: {
        nl: 'Sinaasappel, orange, sinaasappelen, mandarijn, madarijnen, clementine, clementinen',
        en: 'Orange, oranges, clementine, clementines'
      },
      emoji: '🍊',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan sinaasappel geven aan je hond, maar met mate. Haal de pitten eruit, want deze bevat cyanide en verwijder de schil.',
        en: 'Yes, you can give orange to your dog but only in a healthy amount. Make sure to peel it first.'
      }
    },
    {
      food: { nl: 'Ananas, annanas, ananassen, ananasen', en: 'Pineapple, pineapples' },
      emoji: '🍍',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan ananas geven aan je hond, maar met mate. Verwijder de harde kern en de schil.',
        en: 'Yes, you can give pineapple to your dog but only in a healthy amount. Take out the hard core and peel the skin off.'
      }
    },
    {
      food: { nl: 'Frambozen, framboos, frambosen', en: 'Raspberries, raspberry' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan frambozen aan je hond geven, maar hou je vast aan een bepaalde maximum hoeveelheid.',
        en: 'Yes, you can give raspberries to your dog, but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Nectarine, nectarinen', en: 'Nectarine, nectarines' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan nectarine aan je hond geven, maar met mate. Haal de pitten eruit, want deze bevatten cyanide.',
        en: 'Yes, you can give nectarine to your dog but only in a healthy amount. Make sure to take out the pit as it contains cyanide and can cause dangerous intestinal blockages.'
      }
    },
    {
      food: { nl: 'Pruim, pruimen', en: 'Plum, plums' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan pruim aan je hond geven, maar met mate. Haal de pit eruit, want deze bevat cyanide.',
        en: 'Yes, you can give plum to your dog but only in a healthy amount. Make sure to take out the pit as it contains cyanide and can cause dangerous intestinal blockages in small dogs.'
      }
    },
    {
      food: { nl: 'Kokosnoot, cocosnoot, kokosnoten, cocosnoten', en: 'Coconut, coconuts' },
      emoji: '🥥',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan kokosnoot aan je hond geven, maar hou je vast aan een bepaalde maximum hoeveelheid.',
        en: 'Yes, you can give coconut to your dog, but limit it as coconut is high in fat.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-coconut/">here</a>.'
      }
    },
    {
      food: { nl: 'Kers, kersjes, kersen, rode kers', en: 'Cherry, cherries, red cherry' },
      emoji: '🍒',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan kersen aan je hond geven, maar hou je vast aan een bepaalde maximum hoeveelheid. Haal de pitten eruit, want deze bevatten cyanide.',
        en: 'Yes, you can give cherry to your dog, but stick to a certain maximum amount. Take out the pits as they contain cyanide and can cause tooth damage.'
      }
    },
    {
      food: { nl: "Papaja, papajas, papaja's", en: 'Papaya, papayas' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan papaja aan je hond geven, maar met mate. Haal de pitten eruit, want deze bevatten cyanide.',
        en: 'Yes, you can give papaya to your dog but only in a healthy amount. Take out the pits as they contain cyanide.'
      }
    },
    {
      food: { nl: 'Pompoen, pompoenen, pompoens', en: 'Pumpkin, pumpkins' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan pompoen aan je hond geven, maar met mate. Haal de pitten eruit, want deze bevatten cyanide.',
        en: 'Yes, you can give pumpkin to your dog but only in a healthy amount.'
      }
    },
    {
      food: {
        nl: 'Druiven, druif, groene druif, groene druiven, rode druif, rode druiven, blauwe druif, blauwe druiven',
        en: 'Grapes, grape, green grape, blue grape, red grape, red grapes, blue grapes, green grapes'
      },
      emoji: '🍇',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen druiven aan je hond geven! Kleine hoeveelheden kunnen reeds toxisch zijn en nierfalen veroorzaken.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-honden-druiven-en-rozijnen/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should never give even a few grapes to your dog! They can cause severe kidney damage and failure.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-grapes-or-raisins-read-first/">here</a>.'
      }
    },
    {
      food: { nl: 'Rozijnen, rozijn', en: 'Raisins, raisin' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen rozijnen aan je hond geven! Kleine hoeveelheden kunnen reeds toxisch zijn en nierfalen veroorzaken.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-honden-druiven-en-rozijnen/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should never give even a few raisins to your dog! They can cause severe kidney damage and failure.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-grapes-or-raisins-read-first/">here</a>.'
      }
    },
    {
      food: {
        nl: "Kiwi, kiwis, kiwi's, gele kiwi, groene kiwi, groene kiwi's, kiwis, gele kiwis, gele kiwi's",
        en: 'Kiwi, kiwis, green kiwi, yellow kiwi, gold kiwi'
      },
      emoji: '🥝',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan kiwi aan je hond geven, maar met mate.',
        en: 'Yes, you can give kiwi to your dog but only in a healthy amount.'
      }
    },
    {
      food: { nl: "Avocado, advocado, avocados, avocado's, advocados, advocado's", en: 'Avocado, avocados, avacadoes' },
      emoji: '🥑',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen avocado aan je hond geven! Advocado bevat persine, wat giftig kan zijn voor je hond.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-honden-avocado/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give avocado to your dog! Avocado contains persin, which can be toxic.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-avocado-are-avocados-good-for-dogs/">here</a>.'
      }
    },
    {
      food: { nl: 'Olijf, olijven', en: 'Olive, olives' },
      emoji: '🫒',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan olijf aan je hond geven, maar met mate.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-honden-olijven/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give olives to your dog but only in a healthy amount. Make sure to remove the pits as they can cause damage to the teeth.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-olives-are-they-good-for-them/">here</a>.'
      }
    },
    {
      food: { nl: 'Watermeloen, watermeloenen, watermeloens', en: 'Watermelon, watermelons' },
      emoji: '🍉',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan waternoeloen aan je hond geven, maar met mate.',
        en: 'Yes, you can give watermelon to your dog but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Granaatappel, granaatappels', en: 'Pomegranate, pomegranates' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen granaatappel aan je hond geven! Sommige honden krijgen hier maag-darmklachten van.',
        en: 'No, you should not give pomegranate to your dog! It may cause gastrointestinal upset.'
      }
    },
    {
      food: { nl: 'Dadel, dadels', en: 'Dates, date' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan dadel aan je hond geven, maar met mate.',
        en: 'Yes, you can give dates to your dog but only in a healthy amount. Make sure to remove the pits as they can cause damage to the teeth.'
      }
    },
    {
      food: { nl: 'Veenbessen, veenbes', en: 'Cranberry, cranberries' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan veenbessen aan je hond geven, maar met mate.',
        en: 'Yes, you can give cranberry to your dog but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Pompelmoes, pompelpoezen', en: 'Grapefruit, grapefruits' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen pompelmoes aan je hond geven! De essentiële oliën en psoralen die deze vrucht bevatten kunnen toxisch zijn.',
        en: 'No, you should not give grapefruit to your dog! This fruit contains psoralens and essential oils which can be toxic.'
      }
    },
    {
      food: { nl: 'Limoen, limoenen', en: 'Lime, limes' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen limoen aan je hond geven! Sommige honden krijgen hier maag-darmklachten van.',
        en: 'No, you should not give lime to your dog! Some dogs get gastrointestinal problems from lime.'
      }
    },
    {
      food: { nl: 'Citroen, citroenen, citroens', en: 'Lemon, lemons' },
      emoji: '🍋',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen citroen aan je hond geven! De essentiële oliën en psoralen die deze vrucht bevatten kunnen toxisch zijn.',
        en: 'No, you should not give lemon to your dog! This fruit contains psoralens and essential oils which can be toxic.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-lemons-are-lemons-healthy-for-dogs/">here</a>.'
      }
    },
    {
      food: { nl: 'Broccoli, brokkoli, broccolie, brokkolie, brokkolies, broccolies', en: 'Broccoli, Broccolis' },
      emoji: '🥦',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan broccoli aan je hond geven, maar met mate. Kook de broccoli, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give broccoli to your dog but only in a healthy amount. Cook the broccoli so it is easier to digest.'
      }
    },
    {
      food: { nl: 'Bloemkool, bloemkolen', en: 'Cauliflower, Cauliflowers' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan bloemkool aan je hond geven, maar met mate. Kook de bloemkool, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give cauliflower to your dog but only in a healthy amount. Cook the cauliflower so it is easier to digest.'
      }
    },
    {
      food: {
        nl: 'Kool, kolen, rode kool, witte kool, zuurkool, spruiten, spruitjes, spruit',
        en: 'Cabbage, Cabbages, red cabbage, white cabbage, sauerkraut, sprouts, Brussels sprouts, sprouts'
      },
      emoji: '🥬',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan kool aan je hond geven, maar met mate. Kook de kool, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give cabbage to your dog but only in a healthy amount. Cook the cabbage so it is easier to digest.'
      }
    },
    {
      food: { nl: 'Groene bonen, bonen, groene boon, groene bonen', en: 'Green beans, Green bean, bean, beans, string bean, string beans' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan groene aan je hond geven, maar met mate. Kook de bonen, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give green beans to your dog but only in a healthy amount. Cook the green beans so they are easier to digest.'
      }
    },
    {
      food: { nl: 'Spinazie', en: 'Spinach' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan spinazie aan je hond geven, maar hou je vast aan een bepaalde maximum hoeveelheid. Vermijd het als je hond nierproblemen heeft.',
        en: 'Yes, you can give spinach to your dog, but stick to a certain limited amount. Avoid if your dog has any known kidney issues.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-spinach/">here</a>.'
      }
    },
    {
      food: { nl: 'Aardappelen, aardappel', en: 'Potatoes, potato' },
      emoji: '🥔',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan aardappel aan je hond geven, maar met mate. Geef geen rauwe aardappel!  Kook de aardappel, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give potatoes to your dog but only in a healthy amount. Don\'t give raw potato! Cook the potatoes so they are easier to digest.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-potatoes/">here</a>.'
      }
    },
    {
      food: { nl: 'Tomaat, tomaten', en: 'Tomato, Tomatos, tomatoes' },
      emoji: '🍅',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan tomaat aan je hond geven, maar met mate. Geef enkel rijpe tomaten. De bladeren bevatten solaline, wat toxisch kan zijn in grote hoeveelheden.',
        en: 'Yes, you can give tomatoes to your dog, but only in healthy amount. Only ripe tomatoes. The leaves contain solalin, which can be toxic in large quantities.'
      }
    },
    {
      food: { nl: 'Wortel, wortelen, wortels', en: 'Carrot, carrots' },
      emoji: '🥕',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan wortel aan je hond geven, maar met mate.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-wortel/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give carrot to your dog but only in a healthy amount.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-carrots-are-they-healthy/">here</a>.'
      }
    },
    {
      food: { nl: 'Maïs, mais', en: 'Corn, maize, corns' },
      emoji: '🌽',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan maïs aan je hond geven, maar met mate.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-mais/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give corn to your dog but only in a healthy amount.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-corn-is-it-ok-for-dogs-to-eat-corn/">here</a>.'
      }
    },
    {
      food: { nl: 'Courgette, courgettes', en: 'Zucchini, Zucchinis' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan courgette aan je hond geven, maar met mate.',
        en: 'Yes, you can give zucchini to your dog but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Venkel, venkels', en: 'Fennel, Fennels' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan venkel aan je hond geven, maar met mate.',
        en: 'Yes, you can give fennel to your dog but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Erwtjes, erwt, erwten, groene erwten, groene erwt', en: 'Pea, peas' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan erwtjes aan je hond geven, maar met mate.',
        en: 'Yes, you can give peas to your dog but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Knolselder, knolsederij, knolselders', en: 'Celeriac' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan knolselder aan je hond geven, maar met mate.',
        en: 'Yes, you can give celeriac to your dog but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Komkommer, komkommers', en: 'Cucumber, cucumbers' },
      emoji: '🥒',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan komkommer aan je hond geven, maar met mate.',
        en: 'Yes, you can give cucumber to your dog but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Paddenstoel, Champignon, champignons, champignonen, paddenstoelen', en: 'Mushroom, Mushrooms' },
      emoji: '🍄',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen paddenstoel/ champignon aan je hond geven! De meeste paddenstoelen zijn niet giftig voor honden, maar sommige zijn extreem giftig.',
        en: 'No, you should not give mushrooms to your dog! Most mushrooms aren’t toxic to dogs, but some are extremely toxic.'
      }
    },
    {
      food: {
        nl: "Paprika, paprika's, paprikas, groene paprika, groene paprika's, gele paprika's, gele paprika, rode paprika, rode paprika's",
        en: 'Pepper, peppers, green pepper, green peppers, capsicum'
      },
      emoji: '🫑',
      category: 'OK_MOST_CASES',
      answer: { nl: 'Nee, je mag geen paprika aan je hond geven!', en: 'No, you should not give pepper to your dog!' }
    },
    {
      food: { nl: 'Prei, preien', en: 'Leeks, leek' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen prei aan je hond geven! Prei is toxisch en kan schade veroorzaken aan de rode bloedcellen.',
        en: 'No, you should not give leeks to your dog! Leeks are toxic and can cause damage to red blood cells.'
      }
    },
    {
      food: { nl: 'Rabarber', en: 'Rhubarb' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen rabarber aan je hond geven! De bladeren kunnen toxisch zijn.',
        en: 'No, you should not give rhubarb to your dog! The leaves can be poisonous.'
      }
    },
    {
      food: { nl: 'Radijs, radijzen', en: 'Radish, radishes, radishs' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan radijs aan je hond geven, maar met mate.',
        en: 'Yes, you can give radish to your dog but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Ui, uien, uitjes', en: 'Onion, onions, red onions, red onion' },
      emoji: '🧅',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen ui aan je hond geven! Ui bevat thiosulfaat, wat zeer giftig is.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-honden-uien-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give onions to your dog! They contains thiosulfate, which is very toxic.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-onions-heres-why-they-shouldnt/">here</a>.'
      }
    },
    {
      food: { nl: 'Witloof, witloven', en: 'Chicory, endive' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan witloof aan je hond geven, maar met mate. Kook de witloof, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give endive to your dog but only in a healthy amount. Cook the endive so it is easier to digest.'
      }
    },
    {
      food: { nl: 'Aubergine, aubergines', en: 'Eggplant, eggplants' },
      emoji: '🍆',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan aubergine aan je hond geven, maar met mate. Kook de aubergine, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give eggplant to your dog but only in a healthy amount. Cook the eggplant so it is easier to digest.'
      }
    },
    {
      food: { nl: 'Knoflook', en: 'Garlic' },
      emoji: '🧄',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen knoflook aan je hond geven! Zelfs in kleine hoeveelheid is het erg giftig! <br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/wat-mogen-honden-niet-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give garlic to your dog! It contains thiosulfate, which is very toxic.'
      }
    },
    {
      food: { nl: "Jalapeno, jalapeno's, jalapeño's, jalapeño", en: 'Jalapeno, jalapenos, jalapeño, jalapeños' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen jalapeno aan je hond geven! Het is niet giftig, maar heeft een veel te pittige smaak.',
        en: 'No, you should not give jalapeno to your dog! Not toxic, but too spicy taste for a dog.'
      }
    },
    {
      food: { nl: 'Chili, chilipeper, chilipepers, rode chilipeper, rode chili, rode chilipepers', en: 'Chilli, chillipepper, chillies' },
      emoji: '🌶️',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen chili aan je hond geven! Chili bevat een stof genaamd capsaïcine die irriterend werkt voor honden.',
        en: 'No, you should not give chillis to your dog! They contain a substance called capsaicin that acts as an irritant to dogs.'
      }
    },
    {
      food: { nl: 'Bieslook', en: 'Chives' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen bieslook aan je hond geven! Zelfs in kleine hoeveelheid is het erg giftig!',
        en: 'No, you should not give garlic to your dog! Even in small amounts it may be toxic<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-onions-garlic-or-chives-read-first/">here</a>.'
      }
    },
    {
      food: { nl: 'Ijs, ijsjes', en: 'Ice cream' },
      emoji: '🍨',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen ijs aan je hond geven! Het kan maag-darmklachten veroorzaken en heeft een te hoge suikergehalte.',
        en: 'No, you should not give ice cream to your dog! It contains too much sugar and can lead to gastrointestinal issues.'
      }
    },
    {
      food: { nl: 'Chips, chip', en: 'Chips, chip, potato chip, potato chips' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen chips aan je hond geven! Chips heeft een te hoge zoutgehalte dat toxisch zijn voor je hond.',
        en: 'No, you should not give chips to your dog! Chips are very high in fat and salt - which can be toxic to dogs.'
      }
    },
    {
      food: { nl: 'Nutella, choco', en: 'Nutella' },
      emoji: '🍫',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen nutella aan je hond geven! Nutella heeft een te hoge suikergehalte.',
        en: 'No, you should not give nutella to your dog! Nutella contains far too much fat and sugar.'
      }
    },
    {
      food: { nl: "Pizza, stuk pizza, pizza's", en: 'Pizza, pizza pie' },
      emoji: '🍕',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen pizza aan je hond geven! Pizza heeft geen voedingswaarde voor je hond en bevat vaak ui-knoflook.',
        en: 'No, you should not give pizza to your dog! Pizza has no nutritional value and often contains onions and garlic - which are toxic.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-pizza-heres-why-its-not-safe/">here</a>.'
      }
    },
    {
      food: { nl: 'Chocolade, choco, melkchocolade, pure chocolade, puur chocolade', en: 'Chocolate, chocolates' },
      emoji: '🍫',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen chocolade aan je hond geven! Hoe donkerder de chocolade is, hoe groter de hoeveelheid theobromine, hoe gevaarlijker.  <br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/wat-mogen-honden-niet-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give chocolate to your dog! Chocolate contains theobromine, which is toxic to dogs. The darker the chocolate is, the more dangerous it is.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-chocolate-why-is-it-toxic/">here</a>.'
      }
    },
    {
      food: { nl: 'Confituur, jam', en: 'Jelly, jam, spread' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen confituur aan je hond geven! Confituur heeft een te hoge suikergehalte.',
        en: 'No, you should not give jam to your dog! Jam has no nutritional value and contains too much sugar.'
      }
    },
    {
      food: { nl: 'Nootmuskaat', en: 'Nutmeg, nutmegs' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen nootmuskaat aan je hond geven! Het bevat een toxische stof namelijk myristicine.',
        en: 'No, you should not give nutmeg to your dog! It contains a toxic substance - myristicin.'
      }
    },
    {
      food: { nl: 'Gistdeeg, deeg, brooddeeg, gist, rauw deeg', en: 'Yeast dough, yeast, dough, raw dough, fresh dough' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen gistdeeg aan je hond geven! Het gist in deeg kan ernstige maag-darmproblemen veroorzaken.',
        en: 'No, you should not give yeast dough to your dog! The yeast can expand internally and cause major problems in the stomach and intestines.'
      }
    },
    {
      food: { nl: 'Rijst, witte rijst, bruine rijst', en: 'Rice, white rice, brown rice' },
      emoji: '🍚',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan rijst aan je hond geven, maar met mate. Zorg dat de rijst gekookt is.',
        en: 'Yes, you can give rice to your dog, but only in a healthy amount. Make sure the rice is cooked properly.'
      }
    },
    {
      food: { nl: 'Cornflakes, cereals', en: 'Cereal, cereals' },
      emoji: '🌾',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je mag cornflakes in kleine hoeveelheden aan je hond geven! Bij grote hoeveelheden heb je kans op ontwikkeling van obesitas.',
        en: 'Yes, you can give cereal to your dog in limited amounts. Cereals in general contain many calories, making obesity a risk.'
      }
    },
    {
      food: { nl: 'Friet, frieten, patat', en: 'French Fries, french fry, fries' },
      emoji: '🍟',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen frieten/patat aan je hond geven! Frieten/Patat hebben een te hoge zoutgehalte.',
        en: 'No, you should not give french fries to your dog! French fries have no nutrional value and contain far too much salt - which is toxic to dogs.'
      }
    },
    {
      food: {
        nl: 'Brood, wit brood, bruin brood, pistolet, croissant, sandwich, sandwiches, puntje',
        en: 'Bread, croissants, croissant, sandwich'
      },
      emoji: '🍞',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan brood aan je hond geven, maar met mate.',
        en: 'Yes, you can give bread to your dog, but only in a limited amount. Bread contains many calories, making obesity a risk.'
      }
    },
    {
      food: { nl: "Pasta, pasta's", en: 'Pasta, pastas' },
      emoji: '🍝',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan pasta aan je hond geven, maar met mate. Zorg dat de pasta gekookt is.',
        en: 'Yes, you can give pasta to your dog, but only in a healthy amount. Make sure the rice is cooked properly.'
      }
    },
    {
      food: { nl: 'Havermout, oatmeal', en: 'Oatmeal' },
      emoji: '🌾',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan havermout aan je hond geven, maar met mate',
        en: 'Yes, you can give oatmeal to your dog, but only in a healthy amount.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-oatmeal/">here</a>.'
      }
    },
    {
      food: { nl: 'Vis, visjes', en: 'Fish, fishes, fish meat' },
      emoji: '🐟',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan vis aan je hond geven, als alles goed gekookt is en alle botjes zijn verwijderd.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-vis-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give fish to your dog. Avoid raw fish due to the risk of contamination. Never give fish bones!<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-fish/">here</a>.'
      }
    },
    {
      food: { nl: 'Zalm', en: 'Salmon' },
      emoji: '🍣',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan zalm aan je hond geven, maar met mate. Vermijd rauwe zalm. Rauwe vis heeft een te groot risico op besmetting met bacteriën, virussen en parasieten.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-vis-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give salmon to your dog but only in a healthy amount. Avoid raw salmon due to the risk of contamination.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-fish/">here</a>.'
      }
    },
    {
      food: { nl: 'Tonijn', en: 'Tuna, tunafish' },
      emoji: '🍣',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan tonijn aan je hond geven, maar met mate. Vermijd rauwe tonijn. Rauwe vis heeft een te groot risico op besmetting met bacteriën, virussen en parasieten.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-vis-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give tuna to your dog but only in a healthy amount. Avoid tuna due to the risk of contamination..<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-fish/">here</a>.'
      }
    },
    {
      food: { nl: "Scampi, scampi's, scampies", en: 'Shrimp, shrimps' },
      emoji: '🦐',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan scampi aan je hond geven, maar hou je vast aan een bepaalde maximum hoeveelheid Vermijd rauwe scampi. <br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-vis-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give shrimp but only in a healthy amount. Avoid raw shrimp due to the risk of contamination..<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-fish/">here</a>.'
      }
    },
    {
      food: { nl: "Gamba, gamba's, gambas", en: 'Prawn, prawns' },
      emoji: '🦐',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan gamba aan je hond geven, maar hou je vast aan een bepaalde maximum hoeveelheid. Bak de gamba en verwijder de schelp.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-vis-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give prawn to your dog, but stick to a certain maximum amount.  Make sure to cook it and remove the shell.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-fish/">here</a>.'
      }
    },
    {
      food: { nl: 'Sushi', en: 'Sushi' },
      emoji: '🍣',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen sushi aan je hond geven. Rauwe vis heeft een te groot risico op besmetting met bacteriën, virussen en parasieten.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-vis-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give sushi to your dog. Unless you know the exact ingredients, you don\'t know if there are toxic items within.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-fish/">here</a>.'
      }
    },
    {
      food: { nl: 'Bot, botten, been', en: 'Bone, bones' },
      emoji: '🦴',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan een bot aan je hond geven, maar hou je vast aan bepaalde voorwaarden. (zie hiervoor blog) (enkel rauw, geen gevogelte of varken)<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/wat-mogen-honden-niet-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'While you can give certain types of bones to dogs, giving the wrong types can have deadly consequences with intestinal blockage and rupture. Certainly avoid poultry and pork bones along with cooked bones of any kind.'
      }
    },
    {
      food: { nl: 'Kip, gevogelte', en: 'Chicken, chicken meat, poultry' },
      emoji: '🐔',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan kip aan je hond geven, maar met mate. Vermijd rauwe kip omwille van het risico op bacteriën.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-kip-eten-dit-moet-je-weten/ in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give chicken to your dog, but only in a healthy amount. Avoid raw chicken due to the risk of contamination.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-chicken-what-you-should-know/">here</a>.'
      }
    },
    {
      food: { nl: 'Varken, varkensvlees, varkenshaasje', en: 'Pork, pig' },
      emoji: '🐖',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan varken aan je hond geven, maar met mate. Vermijd rauw vlees omwille van het risico op bacteriën.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-rauw-vlees-of-is-rauw-vlees-gevaarlijk/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give pork to your dog, but only in a healthy amount. Avoid raw meat due to the risk of contamination.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-pork/">here</a>.'
      }
    },
    {
      food: { nl: 'Rund, Koe, rundvlees', en: 'Beef, cow, cow meat' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan rund aan je hond geven, maar met mate. Vermijd rauw vlees omwille van het risico op bacteriën.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-rauw-vlees-of-is-rauw-vlees-gevaarlijk/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give beef to your dog, but only in a healthy amount. Avoid raw meat due to the risk of contamination.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-raw-meat-think-again/">here</a>.'
      }
    },
    {
      food: { nl: 'Beef jerky', en: 'Beef jerky, jerky, dried meat, salted meat' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan beef jerky aan je hond geven, maar hou je vast aan bepaalde voorwaarden. Vermijd pittige of met knoflook-ui smaak.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-rauw-vlees-of-is-rauw-vlees-gevaarlijk/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give beef jerky to your dog, but only in very limited quantities. Beef jerky contains a lot of salt, which isn\'t good for dogs. Avoid spicy or garlic-onion flavored ones.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-raw-meat-think-again/">here</a>.'
      }
    },
    {
      food: { nl: 'Ham, gekookte ham', en: 'Ham' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan ham aan je hond geven, maar met mate.',
        en: 'Yes, you can give ham to your dog, but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Spek, bacon', en: 'Bacon' },
      emoji: '🥓',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan spek aan je hond geven, maar lees eerst de blog.',
        en: 'Yes, you can give bacon to your dog, but only in very limited quantities. Bacon contains a lot of fat and salt, which aren\'t good for dogs!<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-bacon-is-bacon-toxic-for-dogs/">here</a>.'
      }
    },
    {
      food: { nl: 'Worst, worstjes, worsten', en: 'Sausage, sausages' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen worst aan je hond geven. Het is te pikant en te zoutig.',
        en: 'No, you should not give sausage to your dog. It contains too much fat and salt (among potentially other toxic ingredients such as garlic).'
      }
    },
    {
      food: { nl: 'Steak, Biefstuk, biefstukken', en: 'Steak, steaks' },
      emoji: '🥩',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan steak/ biefstuk aan je hond geven, maar met mate. Vermijd rauw vlees omwille van het risico op bacteriën.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-rauw-vlees-of-is-rauw-vlees-gevaarlijk/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give steak to your dog, but only in a healthy amount. Avoid raw meat due to the risk of contamination.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-raw-meat-think-again/">here</a>.'
      }
    },
    {
      food: { nl: '', en: '' },
      emoji: '',
      category: '',
      answer: { nl: '', en: '' }
    },
    {
      food: { nl: 'Melk, room', en: 'Milk, cream' },
      emoji: '🥛',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen melk aan je hond geven! Het kan ernstige maag-darmklachten veroorzaken, omdat honden moeilijk lactase verteren.',
        en: 'No, you should not give milk to your dog! Many dogs are lactose-intolerant, and thus it can lead to gastrointestinal problems.'
      }
    },
    {
      food: { nl: 'Kaas', en: 'Cheese' },
      emoji: '🧀',
      category: 'OK_VERY_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan kaas aan je hond geven, maar hou je vast aan een bepaalde zeer kleine hoeveelheid. Het kan maag-darmklachten veroorzaken.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-kaas-is-kaas-gezond/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give cheese to your dog, but stick to a certain small amount. It may cause gastrointestinal problems.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-cheese-is-it-healthy/">here</a>.'
      }
    },
    {
      food: { nl: 'Geitenkaas', en: 'Goat cheese' },
      emoji: '',
      category: 'OK_VERY_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan geitenkaas aan je hond geven, maar hou je vast aan een bepaalde zeer kleine hoeveelheid. Het kan maag-darmklachten veroorzaken.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-kaas-is-kaas-gezond/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give goat cheese to your dog, but stick to a certain small amount. It may cause gastrointestinal problems.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-cheese-is-it-healthy/">here</a>.'
      }
    },
    {
      food: { nl: 'Hüttenkäse, cottage cheese', en: 'Cottage cheese' },
      emoji: '',
      category: 'OK_VERY_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan cottage cheese aan je hond geven, maar hou je vast aan een bepaalde zeer kleine hoeveelheid. Het kan maag-darmklachten veroorzaken.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-kaas-is-kaas-gezond/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give cottage cheese to your dog, but stick to a certain small amount. It may cause gastrointestinal problems.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-cheese-is-it-healthy/">here</a>.'
      }
    },
    {
      food: { nl: 'Brie', en: 'Brie' },
      emoji: '',
      category: 'OK_VERY_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan brie aan je hond geven, maar hou je vast aan een bepaalde zeer kleine hoeveelheid. Het kan maag-darmklachten veroorzaken.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-kaas-is-kaas-gezond/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give brie to your dog, but stick to a certain small amount. It may cause gastrointestinal problems.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-cheese-is-it-healthy/">here</a>.'
      }
    },
    {
      food: { nl: 'Yoghurt, Yogurt', en: 'Yogurt, yoghurt' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan yoghurt aan je hond geven, maar hou je vast aan een bepaalde maximum hoeveelheid en vermijd zoete varianten. Het kan maag-darmklachten veroorzaken.',
        en: 'Yes, you can give yogurt to your dog, but stick to a certain maximum amount and avoid sweetened ones. It may cause gastrointestinal problems.'
      }
    },
    {
      food: { nl: 'Ei, eieren', en: 'Egg, eggs' },
      emoji: '🥚',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan ei aan je hond geven, maar met mate. Geef nooit een rauw ei.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-hond-kaas-is-kaas-gezond/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give egg to your dog, but only in a healthy amount. Avoid raw eggs due to the risk of contamination.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-eggs/">here</a>.'
      }
    },
    {
      food: { nl: 'Macadamia noten, macadamia noot', en: 'Macadamia nuts, macadamia, macadamia nut' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen macadamia nootjes aan je hond geven! Het zou je hond erg ziek maken.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/wat-mogen-honden-niet-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give macadamia nuts to your dog! They can be very toxic and make your dog very sick.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-nuts-what-nuts-can-dogs-eat/">here</a>.'
      }
    },
    {
      food: { nl: 'Amandelen, amandel, noot, noten', en: 'Almonds, almond, almond nuts, nuts, nut' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen amandelen aan je hond geven! Het zou je hond erg ziek maken.',
        en: 'No, you should not give almonds to your dog! Dogs do not digest them well and they can cause gastrointestinal issues.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-nuts-what-nuts-can-dogs-eat/">here</a>.'
      }
    },
    {
      food: { nl: 'Cashewnoten, cashewnoot, noten, noot', en: 'Cashews, cashew, cashew nuts, nuts, nut' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan cashewnoten aan je hond geven, maar hou je vast aan een bepaalde maximum hoeveelheid.',
        en: 'Yes, you can give cashews to your dog, but stick to a certain limited amount.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-nuts-what-nuts-can-dogs-eat/">here</a>.'
      }
    },
    {
      food: { nl: 'Walnoot, Okkernoot, okkernoten, walnoten, noten, noot', en: 'Walnut, walnuts, nut, nuts' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen walnoot aan je hond geven! Het zou je hond erg ziek maken.',
        en: 'No, you should not give walnuts to your dog! Some types of walnuts (and especially walnut mold) can lead to neurological problems.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-nuts-what-nuts-can-dogs-eat/">here</a>.'
      }
    },
    {
      food: { nl: 'Honing', en: 'Honey' },
      emoji: '🍯',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan honing aan je hond geven, maar hou je vast aan een bepaalde maximum hoeveelheid.',
        en: 'Yes, you can give honey to your dog, but stick to a certain limited amount.'
      }
    },
    {
      food: { nl: 'Koffie', en: 'Coffee' },
      emoji: '☕',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen koffie aan je hond geven. Koffie bevat cafeïne.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/wat-mogen-honden-niet-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give coffee to your dog. Coffee contains caffeine which is very unhealthy for dogs.'
      }
    },
    {
      food: {
        nl: 'Alcohol, bier, wijn, gin, vodka, wodka, whiskey, champagne, cava',
        en: 'Alcohol, beer, wine, gin, vodka, wodka, whiskey, champagne, cava'
      },
      emoji: '🍷',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen alcohol aan je hond geven. <br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/wat-mogen-honden-niet-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'It goes without saying that no, you should not give alcohol to your dog!'
      }
    },
    {
      food: { nl: 'Thee', en: 'Tea' },
      emoji: '🫖',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen thee aan je hond geven. Thee bevat cafeïne.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/wat-mogen-honden-niet-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give tea to your dog. Tea contains caffeine which is very unhealthy for dogs.'
      }
    },
    {
      food: {
        nl: 'Frisdrank, cola, coca cola, fanta, sprite, pepsi, ice-tea',
        en: 'Soda, pop, sugar drink, coca cola, pepsi, sprite, ice-tea, fanta'
      },
      emoji: '🥤',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen frisdrank aan je hond geven. Frisdrank bevat een te hoog suikergehalte.',
        en: 'No, you should not give soda to your dog. Soda contains too much sugar.'
      }
    },
    {
      food: { nl: 'Snoep, zure snoep, snoepjes, zure beertjes, lolly, lollies', en: 'Candy, gummies, hard candy, gummy bears, lollipops' },
      emoji: '🍬',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen snoep aan je hond geven. Snoep bevat de stof xylitol, die heel toxisch is voor je hond.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/wat-mogen-honden-niet-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give candy to your dog. Candy contains the substance xylitol, which is very toxic to your dog.'
      }
    },
    {
      food: { nl: 'Pindakaas', en: 'Peanut butter' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je mag pindakaas aan je hond geven, maar hou je vast aan bepaalde voorwaarden (zie blog) (enkel natuurlijke pindakaas, zonder xylitol)<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-honden-pindakaas/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, mostly you can give peanut butter to your dog, but only in limited amounts and you must stick to certain conditions. The peanut butter must be unsalted and not contain xylitol.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-dogs-eat-peanut-butter/">here</a>.'
      }
    },
    {
      food: { nl: 'Mayo, Mayonaise', en: 'Mayo, Mayonnaise' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je mag mayo/mayonaise aan je hond geven, maar hou je vast aan bepaalde voorwaarden: zorg dat het geen xylitol bevat (vaak bij lightproducten).',
        en: 'Yes, you can give mayonnaise to your dog, but only in limited amounts and you must stick to certain conditions. Make sure it does not contain xylitol - often found in "Light" products.'
      }
    },
    {
      food: { nl: 'Ketchup', en: 'Ketchup' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je mag ketchup aan je hond geven, maar hou je vast aan bepaalde voorwaarden: zorg dat het geen xylitol bevat (vaak bij lightproducten).',
        en: 'Yes, you can give ketchup to your dog, but only in limited amounts and you must stick to certain conditions. Make sure it does not contain xylitol - often found in "Light" products.'
      }
    },
    {
      food: { nl: 'Mosterd, dijonnaise', en: 'Mustard, dijon mustard, dijon' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen mosterd aan je hond geven. Het kan zorgen voor ontstekingen in het lichaam.',
        en: 'No, you should not give mustard to your dog! Mustard is a toxic compound for dogs, and can lead to serious gastrointestinal issues.'
      }
    }
  ],
  cat: [
    {
      food: { nl: 'Appel, appels, appelen', en: 'Apple, apples' },
      emoji: '🍏, 🍎',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan een appel geven aan je kat, maar met mate. Haal de pitten eruit, want deze bevatten cyanide.',
        en: 'Yes, you can give apple to your cat but only in a healthy amount. Make sure to take out the pits as they contain cyanide.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-apples/">here</a>.'
      }
    },
    {
      food: { nl: 'Peer, peren, peers', en: 'Pear, pears' },
      emoji: '🍐',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan een peer geven aan je kat, maar met mate. Haal de pitten eruit, want deze bevatten cyanide.',
        en: 'Yes, you can give pear to your cat but only in a healthy amount. Make sure to take out the pits as they contain cyanide.'
      }
    },
    {
      food: { nl: 'Blauwe bessen, bessen, blauwe bes, blauwebes, blauwebessen', en: 'Blueberries, blueberry, blue berry, blue berries' },
      emoji: '🫐',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan blauwe bessen geven aan je kat, maar met mate.',
        en: 'Yes, you can give blueberries to your cat but only in a healthy amount.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-blueberries/">here</a>.'
      }
    },
    {
      food: { nl: 'Aardbei, aarbeien', en: 'Strawberries, strawberry' },
      emoji: '🍓',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan aardbeien geven aan je kat, maar hou je vast aan een bepaalde maximum hoeveelheid.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-aardbeien-zijn-aardbeien-gezond/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give strawberries to your cat but only in a healthy amount.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-strawberries-are-they-safe-for-them">here</a>.'
      }
    },
    {
      food: { nl: 'Banaan, bananen', en: 'Banana, bananas' },
      emoji: '🍌',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan banaan geven aan je kat, maar hou je vast aan bepaalde voorwaarden. (zie blog)<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-banaan-zijn-bananen-gezond/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give banana to your cat, but stick to certain conditions.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-bananas-are-bananas-good-for-cats">here</a>.'
      }
    },
    {
      food: { nl: "Mango, mango's, mangos", en: 'Mango, mangos, mangoes' },
      emoji: '🥭',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan mango geven aan je kat, maar met mate. Haal de pit eruit, want deze bevat cyanide.',
        en: 'Yes, you can give mango to your cat but only in a healthy amount. Take out the pit as it contains cyanide.'
      }
    },
    {
      food: { nl: 'Abrikoos, abrikozen, abrikosen', en: 'Apricot, Apricots' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan abrikoos geven aan je kat, maar met mate. Haal de pit eruit, want deze bevat cyanide.',
        en: 'Yes, you can give apricot to your cat but only in a healthy amount. Take out the pit as it contains cyanide and is a choking hazard.'
      }
    },
    {
      food: {
        nl: 'Meloen, meloenen, meloens, watermeloen, water meloen, watermeloenen, cantaloupe, cantaloupen',
        en: 'Cantaloupe, Cantaloupes, honeydew, melon, melons'
      },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan meloen geven aan je kat, maar met mate. Haal de pitten eruit, want deze bevat cyanide en vergeet niet de meloen te schillen.',
        en: "Yes, you can give cantaloupe to your cat but only in a healthy amount. Take out the pits as they contain cyanide, and don't forget to peel the cantaloupe."
      }
    },
    {
      food: {
        nl: 'Sinaasappel, orange, sinaasappelen, mandarijn, madarijnen, clementine, clementinen',
        en: 'Orange, oranges, clementine, clementines'
      },
      emoji: '🍊',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan sinaasappel geven aan je kat, maar met mate. Haal de pitten eruit, want deze bevat cyanide en verwijder de schil.',
        en: 'Yes, you can give orange to your cat but only in a healthy amount. Take out the pits as they contain cyanide, and peel the skin off.'
      }
    },
    {
      food: { nl: 'Ananas, annanas, ananassen, ananasen', en: 'Pineapple, pineapples' },
      emoji: '🍍',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan ananas geven aan je kat, maar met mate. Verwijder de harde kern en de schil.',
        en: 'Yes, you can give pineapple to your cat but only in a healthy amount. Take out the hard core and peel the skin off.'
      }
    },
    {
      food: { nl: 'Frambozen, framboos, frambosen', en: 'Raspberries, raspberry' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan frambozen aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid.',
        en: 'Yes, you can give raspberries to your cat but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Nectarine, nectarinen', en: 'Nectarine, nectarines' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan nectarine aan je kat geven, maar met mate. Haal de pitten eruit, want deze bevatten cyanide.',
        en: 'Yes, you can give nectarine to your cat but only in a healthy amount. Take out the pit as it contains cyanide and is a choking hazard.'
      }
    },
    {
      food: { nl: 'Pruim, pruimen', en: 'Plum, plums' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan pruim aan je kat geven, maar met mate. Haal de pit eruit, want deze bevat cyanide.',
        en: 'Yes, you can give plum to your cat but only in a healthy amount. Take out the pit as it contains cyanide and is a choking hazard.'
      }
    },
    {
      food: { nl: 'Kokosnoot, cocosnoot, kokosnoten, cocosnoten', en: 'Coconut, coconuts' },
      emoji: '🥥',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je mag geen kokosnoot aan je kat geven. Maar lees eerst de blog',
        en: 'Yes, you can give coconut to your cat, but there are certain conditions.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-coconut-how-about-coconut-milk">here</a>.'
      }
    },
    {
      food: { nl: 'Kers, kersjes, kersen, rode kers', en: 'Cherry, cherries, red cherry' },
      emoji: '🍒',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan kersen aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid. Haal de pitten eruit, want deze bevatten cyanide.',
        en: 'Yes, you can give cherry to your cat, but stick to a certain maximum amount. Take out the pits as they contain cyanide.'
      }
    },
    {
      food: { nl: "Papaja, papaja's, papajas", en: 'Papaya, papayas' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan papaja aan je kat geven, maar met mate. Haal de pitten eruit, want deze bevatten cyanide.',
        en: 'Yes, you can give papaya to your cat but only in a healthy amount. Take out the pits as they contain cyanide.'
      }
    },
    {
      food: { nl: 'Pompoen, pompoenen, pompoens', en: 'Pumpkin, pumpkins' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan pompoen aan je kat geven, maar met mate. Haal de pitten eruit, want deze bevatten cyanide.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-pompoen-en-is-pompoen-gezond/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give pumpkin to your cat but only in a healthy amount.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-pumpkin-what-are-the-benefits/">here</a>.'
      }
    },
    {
      food: {
        nl: 'Druiven, druif, groene druif, groene druiven, rode druif, rode druiven, blauwe druif, blauwe druiven',
        en: 'Grapes, grape, green grape, blue grape, red grape, red grapes, blue grapes, green grapes'
      },
      emoji: '🍇',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen druiven aan je kat geven! Kleine hoeveelheden kunnen reeds toxisch zijn en nierfalen veroorzaken.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-druiven/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give grapes to your cat! Small amounts can be toxic and cause kidney failure.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-grapes-heres-what-you-should-know/">here</a>.'
      }
    },
    {
      food: { nl: 'Rozijnen, rozijn', en: 'Raisins, raisin' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen rozijnen aan je kat geven! Kleine hoeveelheden kunnen reeds toxisch zijn en nierfalen veroorzaken.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-druiven/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give raisins to your cat! Small amounts can be toxic and cause kidney failure.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-grapes-heres-what-you-should-know/">here</a>.'
      }
    },
    {
      food: {
        nl: "Kiwi, kiwis, kiwi's, gele kiwi, groene kiwi, groene kiwi's, kiwis, gele kiwis, gele kiwi's",
        en: 'Kiwi, kiwis, green kiwi, yellow kiwi, gold kiwi'
      },
      emoji: '🥝',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan kiwi aan je kat geven, maar met mate.',
        en: 'Yes, you can give kiwi to your cat but only in a healthy amount.'
      }
    },
    {
      food: { nl: "Avocado, advocado, avocados, avocado's, advocados, advocado's", en: 'Avocado, avocados, avacadoes' },
      emoji: '🥑',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan avocado aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid.',
        en: 'Yes, you can give avocado to your cat but only in a healthy amount.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-avocado-is-avocado-healthy-to-cats/">here</a>.'
      }
    },
    {
      food: { nl: 'Olijf, olijven', en: 'Olive, olives' },
      emoji: '🫒',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan olijf aan je kat geven, maar met mate.',
        en: 'Yes, you can give olives to your cat but only in a healthy amount. Make sure to take out the pits.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-olives-you-may-be-surprised/">here</a>.'
      }
    },
    {
      food: { nl: 'Watermeloen, watermeloenen, watermeloens', en: 'Watermelon, watermelons' },
      emoji: '🍉',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan waternoeloen aan je kat geven, maar met mate.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-watermeloen/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give watermelon to your cat but only in a healthy amount.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-watermelon-you-may-be-surprised/">here</a>.'
      }
    },
    {
      food: { nl: 'Granaatappel, granaatappels', en: 'Pomegranate, pomegranates' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen granaatappel aan je kat geven! Sommige katen krijgen hier maag-darmklachten van.',
        en: 'No, you should not give pomegranate to your cat! Some cats get gastrointestinal problems from this.'
      }
    },
    {
      food: { nl: 'Dadel, dadels', en: 'Dates, date' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan dadel aan je kat geven, maar met mate.',
        en: 'Yes, you can give dates to your cat but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Veenbessen, veenbes', en: 'Cranberry, cranberries' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan veenbessen aan je kat geven, maar met mate.',
        en: 'Yes, you can give cranberry to your cat but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Pompelmoes, pompelpoezen', en: 'Grapefruit, grapefruits' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen pompelmoes aan je kat geven! De essentiële oliën en psoralen die deze vrucht bevatten kunnen toxisch zijn.',
        en: 'No, you should not give grapefruit to your cat! This fruit contains psoralens and essential oils which could be toxic.'
      }
    },
    {
      food: { nl: 'Limoen, limoenen', en: 'Lime, limes' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen limoen aan je kat geven! Sommige katen krijgen hier maag-darmklachten van.',
        en: 'No, you should not give lime to your cat! Some cats get gastrointestinal problems from this.'
      }
    },
    {
      food: { nl: 'Citroen, citroenen, citroens', en: 'Lemon, lemons' },
      emoji: '🍋',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen citroen aan je kat geven! De essentiële oliën en psoralen die deze vrucht bevatten kunnen toxisch zijn.',
        en: 'No, you should not give lemon to your cat! This fruit contains psoralens and essential oils which could be toxic.'
      }
    },
    {
      food: { nl: 'Broccoli, brokkoli, broccolie, brokkolie, brokkolies, broccolies', en: 'Broccoli, Broccolis' },
      emoji: '🥦',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan broccoli aan je kat geven, maar met mate. Kook de broccoli, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give broccoli to your cat but only in a healthy amount. Cook the broccoli so it is easier to digest.'
      }
    },
    {
      food: { nl: 'Bloemkool, bloemkolen', en: 'Cauliflower, Cauliflowers' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan bloemkool aan je kat geven, maar met mate. Kook de bloemkool, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give cauliflower to your cat but only in a healthy amount. Cook the cauliflower so it is easier to digest.'
      }
    },
    {
      food: {
        nl: 'Kool, kolen, rode kool, witte kool, zuurkool, spruiten, spruitjes, spruit',
        en: 'Cabbage, Cabbages, red cabbage, white cabbage, sauerkraut, sprouts, Brussels sprouts, sprouts'
      },
      emoji: '🥬',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan kool aan je kat geven, maar met mate. Kook de kool, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give cabbage to your cat but only in a healthy amount. Cook the cabbage so it is easier to digest.'
      }
    },
    {
      food: { nl: 'Groene bonen, bonen, groene boon, groene bonen', en: 'Green beans, Green bean, bean, beans, string bean, string beans' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan groene aan je kat geven, maar met mate. Kook de bonen, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give green beans to your cat but only in a healthy amount. Cook the green beans so it is easier to digest.'
      }
    },
    {
      food: { nl: 'Spinazie', en: 'Spinach' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan spinazie aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid. Vermijd het als je kat nierproblemen heeft.',
        en: 'Yes, you can give spinach to your cat, but stick to a certain maximum amount. Avoid if your cat has possible kidney issues.'
      }
    },
    {
      food: { nl: 'Aardappelen, aardappel', en: 'Potatoes, potato' },
      emoji: '🥔',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan aardappel aan je kat geven, maar met mate. Geef geen rauwe aardappel!  Kook de aardappel, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give potatoes to your cat but only in a healthy amount. Don\'t give raw potato! Cook the potatoes so it is easier to digest.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-potatoes/">here</a>.'
      }
    },
    {
      food: { nl: 'Tomaat, tomaten', en: 'Tomato, Tomatos, tomatoes' },
      emoji: '🍅',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan tomaat aan je kat geven, maar let op: Geef enkel rijpe tomaten. De bladeren bevatten solaline, wat toxisch kan zijn in grote hoeveelheden.',
        en: 'Yes, you can give tomatoes to your cat, but only ripe tomatoes, and only in a healthy amount. The leaves contain solalin, which can be toxic in large quantities.'
      }
    },
    {
      food: { nl: 'Wortel, wortelen, wortels', en: 'Carrot, carrots' },
      emoji: '🥕',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan wortel aan je kat geven, maar met mate. <br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-wortel-zijn-wortels-gezond/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give carrot to your cat but only in a healthy amount.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-carrots-are-carrots-good-for-cats/">here</a>.'
      }
    },
    {
      food: { nl: 'Maïs, mais', en: 'Corn, maize, corns' },
      emoji: '🌽',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan maïs aan je kat geven, maar met mate.',
        en: 'Yes, you can give corn to your cat but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Courgette, courgettes', en: 'Zucchini, Zucchinis' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan courgette aan je kat geven, maar met mate.',
        en: 'Yes, you can give zucchini to your cat but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Venkel, venkels', en: 'Fennel' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan venkel aan je kat geven, maar met mate.',
        en: 'Yes, you can give fennel to your cat but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Erwtjes, erwt, erwten, groene erwten, groene erwt', en: 'Pea' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan erwtjes aan je kat geven, maar met mate.',
        en: 'Yes, you can give peas to your cat but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Knolselder, knolsederij, knolselders', en: 'Celeriac' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan knolselder aan je kat geven, maar met mate.',
        en: 'Yes, you can give celeriac to your cat but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Komkommer, komkommers', en: 'Cucumber, cucumbers' },
      emoji: '🥒',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan komkommer aan je kat geven, maar met mate.',
        en: 'Yes, you can give cucumber to your cat but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Paddenstoel, Champignon, champignons, champignonen, paddenstoelen', en: 'Mushroom, Mushrooms' },
      emoji: '🍄',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen paddenstoel/ champignon aan je kat geven! De meeste paddenstoelen zijn niet giftig voor katen, maar sommige zijn extreem giftig.',
        en: 'No, you should not give mushrooms to your cat! Most of the mushrooms aren’t toxic to cats, but some are extremely toxic.'
      }
    },
    {
      food: {
        nl: "Paprika, paprika's, paprikas, groene paprika, groene paprika's, gele paprika's, gele paprika, rode paprika, rode paprika's",
        en: 'Pepper, peppers, green pepper, green peppers, capsicum'
      },
      emoji: '🫑',
      category: 'NOT_OK',
      answer: { nl: 'Nee, je mag geen paprika aan je kat geven!', en: 'No, you should not give pepper to your cat!' }
    },
    {
      food: { nl: 'Prei, preien', en: 'Leeks, leek' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen prei aan je kat geven! Prei is toxisch en kan schade veroorzaken aan de rode bloedcellen.',
        en: 'No, you should not give leeks to your cat! Leeks are toxic and can cause damage to red blood cells.'
      }
    },
    {
      food: { nl: 'Rabarber', en: 'Rhubarb' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen rabarber aan je kat geven! De bladeren kunnen toxisch zijn.',
        en: 'No, you should not give rhubarb to your cat! The leaves can be poisonous.'
      }
    },
    {
      food: { nl: 'Radijs, radijzen', en: 'Radish, radishes, radishs' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan radijs aan je kat geven, maar met mate.',
        en: 'Yes, you can give radish to your cat but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Ui, uien, uitjes', en: 'Onion, onions, red onions, red onion' },
      emoji: '🧅',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen ui aan je kat geven! Ui bevat thiosulfaat, wat zeer giftig is.',
        en: 'No, you should not give onion to your cat! It contains thiosulfate, which is very toxic.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-onions-garlic-or-chives-read-first/">here</a>.'
      }
    },
    {
      food: { nl: 'Witloof, witloven', en: 'Chicory, endive' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan witloof aan je kat geven, maar met mate. Kook de witloof, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give endive to your cat but only in a healthy amount. Cook the endive so it is easier to digest.'
      }
    },
    {
      food: { nl: 'Aubergine, aubergines', en: 'Eggplant, eggplants' },
      emoji: '🍆',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan aubergine aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid. Kook de aubergine, zodat het makkelijker verteerbaar is.',
        en: 'Yes, you can give eggplant to your cat but stick to a certain maximum amount.. Cook the eggplant so it is easier to digest.'
      }
    },
    {
      food: { nl: 'Knoflook', en: 'Garlic' },
      emoji: '🧄',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen knoflook aan je kat geven! Zelfs in kleine hoeveelheid is het erg giftig!',
        en: 'No, you should not give garlic to your cat! Even in small amounts it can be very toxic!<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-onions-garlic-or-chives-read-first/">here</a>.'
      }
    },
    {
      food: { nl: "Jalapeno, jalapeno's, jalapeño's, jalapeño", en: 'Jalapeno, jalapenos, jalapeño, jalapeños' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen jalapeno aan je kat geven! Het is niet giftig, maar heeft een veel te pittige smaak.',
        en: 'No, you should not give jalapeno to your cat! Not toxic, but too spicy taste for a cat.'
      }
    },
    {
      food: { nl: 'Chili, chilipeper, chilipepers, rode chilipeper, rode chili, rode chilipepers', en: 'Chilli, chillipepper, chillies' },
      emoji: '🌶️',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen chili aan je kat geven! Chili bevat een stof genaamd capsaïcine die irriterend werkt voor katen.',
        en: 'No, you should not give chilli to your cat! They do contain a substance called capsaicin that acts as an irritant to cats.'
      }
    },
    {
      food: { nl: 'Bieslook', en: 'Chives' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen bieslook aan je kat geven! Zelfs in kleine hoeveelheid is het erg giftig!',
        en: 'No, you should not give garlic to your cat! Even in small amounts it may be toxic.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-onions-garlic-or-chives-read-first/">here</a>.'
      }
    },
    {
      food: { nl: 'Ijs, ijsjes', en: 'Ice cream' },
      emoji: '🍨',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen ijs aan je kat geven! Het kan maag-darmklachten veroorzaken en heeft een te hoge suikergehalte.',
        en: 'No, you should not give ice cream to your cat! It can cause gastrointestinal problems and has far too much sugar and fat.'
      }
    },
    {
      food: { nl: 'Chips, chip', en: 'Chips, chip, potato chip, potato chips' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen chips aan je kat geven! Chips heeft een te hoge zoutgehalte dat toxisch zijn voor je kat.',
        en: 'No, you should not give chips to your cat! Chips contain a lot of fat and salt, which are not food for your cat. Salt can be toxic in high levels.'
      }
    },
    {
      food: { nl: 'Nutella, choco', en: 'Nutella' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen nutella aan je kat geven! Nutella heeft een te hoge suikergehalte.',
        en: 'No, you should not give nutella to your cat! Nutella contains far too much sugar and fat.'
      }
    },
    {
      food: { nl: "Pizza, stuk pizza, pizza's", en: 'Pizza, pizza pie' },
      emoji: '🍕',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen pizza aan je kat geven! Pizza heeft geen voedingswaarde voor je kat en bevat vaak ui-knoflook.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-pizza-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give pizza to your cat ! Pizza has no nutritional value and contains many things (onion and garloc for example) which may be toxic to cats.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-pizza-is-it-safe/">here</a>.'
      }
    },
    {
      food: { nl: 'Chocolade, choco, melkchocolade, pure chocolade, puur chocolade', en: 'Chocolate, chocolates' },
      emoji: '🍫',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen chocolade aan je kat geven! Hoe donkerder de chocolade is, hoe groter de hoeveelheid theobromine, hoe gevaarlijker.  <br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-chocolade/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give chocolate to your cat! Chocolate contains theobromine, which is toxic to cats. The darker the chocolate is, the greater the amount of theobromine, and the greater the danger.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https:">here</a>//cooperpetcare.com/can-cats-eat-chocolate/.'
      }
    },
    {
      food: { nl: 'Confituur, jam', en: 'Jelly, jam, spread' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen confituur aan je kat geven! Confituur heeft een te hoge suikergehalte.',
        en: 'No, you should not give jam to your cat! Jam contains too much sugar.'
      }
    },
    {
      food: { nl: 'Nootmuskaat', en: 'Nutmeg, nutmegs' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen nootmuskaat aan je kat geven! Het bevat een toxische stof namelijk myristicine.',
        en: 'No, you should not give nutmeg to your cat! It contains a toxic substance namely myristicin.'
      }
    },
    {
      food: { nl: 'Gistdeeg, deeg, brooddeeg, gist, rauw deeg', en: 'Yeast dough, yeast, dough, raw dough, fresh dough' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen gistdeeg aan je kat geven! Het gist in deeg kan ernstige maag-darmproblemen veroorzaken.',
        en: 'No, you should not give yeast dough to your cat! The yeast in dough can cause serious problems in the stomach and intestines.'
      }
    },
    {
      food: { nl: 'Rijst, witte rijst, bruine rijst', en: 'Rice, white rice, brown rice' },
      emoji: '🍚',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan rijst aan je kat geven, maar met mate. Zorg dat de rijst gekookt is.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-rijst-is-rijst-gezond/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give rice to your cat, but only in a healthy amount. Make sure to cook the rice so it is easier to digest.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-rice-is-it-healthy/">here</a>.'
      }
    },
    {
      food: { nl: 'Cornflakes, cereals', en: 'Cereal, cereals' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je mag cornflakes in kleine hoeveelheden aan je kat geven! Bij grote hoeveelheden heb je kans op ontwikkeling van obesitas.',
        en: 'Yes, you can give cereal to your cat, but only in small amounts. Cereal contains many calories, so too much can lead to obesity.'
      }
    },
    {
      food: { nl: 'Friet, frieten, patat', en: 'French Fries, french fry, fries' },
      emoji: '🍟',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen frieten/patat aan je kat geven! Frieten/Patat hebben een te hoge zoutgehalte.',
        en: 'No, you should not give french fries to your cat! French fries contain far too much fat and salt.'
      }
    },
    {
      food: {
        nl: 'Brood, wit brood, bruin brood, pistolet, croissant, sandwich, sandwiches, puntje',
        en: 'Bread, croissants, croissant, sandwich'
      },
      emoji: '🍞',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan brood aan je kat geven, maar met mate.',
        en: 'Yes, you can give bread to your cat, but only in small amounts. Bread contains many calories, so too much can lead to obesity.'
      }
    },
    {
      food: { nl: "Pasta, pasta's", en: 'Pasta, pastas' },
      emoji: '🍝',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan pasta aan je kat geven, maar met mate. Zorg dat de pasta gekookt is.',
        en: 'Yes, you can give pasta to your cat, but only in a healthy amount. Make sure to cook the pasta so it is easier to digest.'
      }
    },
    {
      food: { nl: 'Havermout, oatmeal', en: 'Oatmeal' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan havermout aan je kat geven, maar met mate',
        en: 'Yes, you can give oatmeal to your cat, but only in small amounts. Oatmeal contains many calories, so too much can lead to obesity.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-oatmeal/">here</a>.'
      }
    },
    {
      food: { nl: 'Vis, visjes', en: 'Fish, fishes, fish meat' },
      emoji: '🐟',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan vis aan je kat geven, als alles goed gekookt is en alle botjes zijn verwijderd.',
        en: 'Yes, you can give fish to your cat, but only if it is cooked properly and all bones are removed. Avoid raw fish due to the risk of contamination.'
      }
    },
    {
      food: { nl: 'Zalm', en: 'Salmon' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan zalm aan je kat geven, maar met mate. Vermijd rauwe zalm. Rauwe vis heeft een te groot risico op besmetting met bacteriën, virussen en parasieten.',
        en: 'Yes, you can give salmon to your cat but only in a healthy amount. Avoid raw salmon due to the risk of contamination.'
      }
    },
    {
      food: { nl: 'Tonijn', en: 'Tuna, tunafish' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan tonijn aan je kat geven, maar met mate. Vermijd rauwe tonijn. Rauwe vis heeft een te groot risico op besmetting met bacteriën, virussen en parasieten.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mag-een-kat-tonijn-uit-blik-eten/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give tuna to your cat but only in a healthy amount. Avoid raw tuna due to the risk of contamination.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-canned-tuna-youll-be-surprised/">here</a>.'
      }
    },
    {
      food: { nl: "Scampi, scampi's, scampies", en: 'Shrimp, shrimps' },
      emoji: '🦐',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan scampi aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid. Vermijd rauwe scampi. Raw fish has too great a risk of contamination with bacteria, viruses and parasites.',
        en: 'Yes, you can give shrimp but only in a healthy amount. Avoid raw shrimp due to the risk of contamination.'
      }
    },
    {
      food: { nl: "Gamba, gamba's, gambas", en: 'Prawn, prawns' },
      emoji: '🦐',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan gamba aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid. Bak de gamba en verwijder de schelp.',
        en: 'Yes, you can give prawns but only in a healthy amount. Avoid raw prawns due to the risk of contamination.'
      }
    },
    {
      food: { nl: 'Sushi', en: 'Sushi' },
      emoji: '🍣',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen sushi aan je kat geven. Rauwe vis heeft een te groot risico op besmetting met bacteriën, virussen en parasieten.',
        en: 'You should not give sushi which contains raw fish or meat. Raw fish or meat has too great a risk of contamination with bacteria, viruses and parasites.'
      }
    },
    {
      food: { nl: 'Bot, botten, been', en: 'Bone, bones' },
      emoji: '🦴',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan een bot aan je kat geven, maar hou je vast aan bepaalde voorwaarden. (zie hiervoor blog) (enkel rauw, geen gevogelte of varken)',
        en: 'While you can give certain types of bones to cats, giving the wrong types can have deadly consequences with intestinal blockage and rupture. Certainly avoid poultry and pork bones along with cooked bones of any kind.'
      }
    },
    {
      food: { nl: 'Kip, gevogelte', en: 'Chicken, chicken meat, poultry' },
      emoji: '🐔',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan kip aan je kat geven, maar met mate. Vermijd rauwe kip omwille van het risico op bacteriën.',
        en: 'Yes, you can give chicken to your cat, but only in a healthy amount. Avoid raw chicken due to the risk of contamination.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-chicken/">here</a>.'
      }
    },
    {
      food: { nl: 'Varken, varkensvlees, varkenshaasje', en: 'Pork, pig' },
      emoji: '🐖',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan varken aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid. Vermijd rauw vlees omwille van het risico op bacteriën.',
        en: 'Yes, you can give pork to your cat, but stick to a certain maximum amount. Avoid raw pork due to the risk of contamination.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-pork-is-pork-bad-for-cats/">here</a>.'
      }
    },
    {
      food: { nl: 'Rund, Koe, rundvlees', en: 'Beef, cow, cow meat' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan rund aan je kat geven, maar met mate. Vermijd rauw vlees omwille van het risico op bacteriën.',
        en: 'Yes, you can give beef to your cat, but only in a healthy amount. Avoid raw beef due to the risk of contamination.'
      }
    },
    {
      food: { nl: 'Beef jerky', en: 'Beef jerky, jerky, dried meat, salted meat' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan beef jerky aan je kat geven, maar hou je vast aan bepaalde voorwaarden. Vermijd pittige of met knoflook-ui smaak.',
        en: "Yes, you can give beef jerky to your cat, but only in very limited quantities. Beef jerky contains a lot of salt, which isn't good for cats. Avoid spicy or garlic-onion flavored ones."
      }
    },
    {
      food: { nl: 'Ham, gekookte ham', en: 'Ham' },
      emoji: '',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan ham aan je kat geven, maar met mate.',
        en: 'Yes, you can give ham to your cat, but only in a healthy amount.'
      }
    },
    {
      food: { nl: 'Spek, bacon', en: 'Bacon' },
      emoji: '🥓',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan spek aan je kat geven, maar met mate.',
        en: "Yes, you can give bacon to your cat, but only in a healthy amount. Bacon contains a lot of fat and salt, which aren't good for cats!"
      }
    },
    {
      food: { nl: 'Worst, worstjes, worsten', en: 'Sausage, sausages' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen worst aan je kat geven. Het is te pikant en te zoutig.',
        en: "No, you should not give sausage to your cat. It's too spicy salty."
      }
    },
    {
      food: { nl: 'Steak, Biefstuk, biefstukken', en: 'Steak, steaks' },
      emoji: '🥩',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan steak/ biefstuk aan je kat geven, maar met mate. Vermijd rauw vlees omwille van het risico op bacteriën.',
        en: 'Yes, you can give steak to your cat, but only in a healthy amount. Avoid raw steak due to the risk of contamination.'
      }
    },
    {
      food: { nl: 'Melk, room', en: 'Milk, cream' },
      emoji: '🥛',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen melk aan je kat geven! Het kan ernstige maag-darmklachten veroorzaken, omdat katten geen lactase verteren.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-kaas/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give milk to your cat! For many cats, it can cause serious gastrointestinal problems because cats have difficulty digesting lactase.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-cheese/">here</a>.'
      }
    },
    {
      food: { nl: 'Kaas', en: 'Cheese' },
      emoji: '🧀',
      category: 'OK_VERY_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan kaas aan je kat geven, maar hou je vast aan een bepaalde zeer kleine hoeveelheid. Het kan maag-darmklachten veroorzaken.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-kaas/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give cheese to your cat, but stick to a certain small amount. It can cause gastrointestinal problems. <br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-cheese/">here</a>.'
      }
    },
    {
      food: { nl: 'Cheddar', en: 'Cheddar' },
      emoji: '',
      category: 'OK_VERY_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan cheddar aan je kat geven, maar hou je vast aan een bepaalde zeer kleine hoeveelheid. Het kan maag-darmklachten veroorzaken.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-kaas/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give cheddar to your cat, but stick to a certain small amount. It can cause gastrointestinal problems.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-cheese/">here</a>.'
      }
    },
    {
      food: { nl: 'Hüttenkäse, cottage cheese', en: 'Cottage cheese' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je kan geen cottage cheese aan je kat geven. Het is een kwarkachtige kaas rijk aan lactose (niet goed voor de gezondheid).<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-kaas/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Nee, you should not give cottage cheese to your cat. Cottage cheese is a cheese rich in lactose, and for many cats, it can cause serious gastrointestinal problems because cats have difficulty digesting lactase.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-cheese/">here</a>.'
      }
    },
    {
      food: { nl: 'Brie', en: 'Brie' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen brie aan je kat geven. Brie wordt gemaakt van rauwe melk die mogelijk Salmonella en Listeria bevat, dit kan ernstige ziekten veroorzaken.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-kaas/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give brie to your cat. Brie is made from raw milk that may contain Salmonella and Listeria, which can cause serious illnesses.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-cheese/">here</a>.'
      }
    },
    {
      food: { nl: 'Mozzarella', en: 'Mozzarella' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen mozzarella aan je kat geven. Mozzarella bevat veel lactose.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-kaas/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'No, you should not give mozzarella to your cat. Mozzarella contains a lot of lactose, and for many cats, it can cause serious gastrointestinal problems because cats have difficulty digesting lactase.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcar">here</a>e.com/can-cats-eat-cheese/.'
      }
    },
    {
      food: { nl: 'Yoghurt, Yogurt', en: 'Yogurt, yoghurt' },
      emoji: '',
      category: 'OK_VERY_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan yoghurt aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid en vermijd zoete varianten. Het kan maag-darmklachten veroorzaken.',
        en: 'Yes, you can give yogurt to your cat, but stick to a certain maximum amount and avoid sweetened yogurt. It can cause gastrointestinal problems.'
      }
    },
    {
      food: { nl: 'Ei, eieren', en: 'Egg, eggs' },
      emoji: '🥚',
      category: 'OK_MOST_CASES',
      answer: {
        nl: 'Ja, je kan ei aan je kat geven, maar met mate. Geef nooit een rauw ei.<br /><br />Voor meer details, lees <a target="_blank" href="https://cooperpetcare.com/nl/mogen-katten-ei/">hier</a> verder in het Cooper Pet Care\'s artikel.',
        en: 'Yes, you can give egg to your cat, but only in a healthy amount. Avoid raw eggs due to the risk of contamination.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.com/can-cats-eat-eggs/">here</a>.'
      }
    },
    {
      food: { nl: 'Macadamia noten, macadamia noot', en: 'Macadamia nuts, macadamia, macadamia nut' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen macadamia nootjes aan je kat geven! Het zou je kat ziek maken.',
        en: 'No, you should not give macadamia nuts to your cat! They can be toxic and make your cat sick.'
      }
    },
    {
      food: { nl: 'Amandelen, amandel, noot, noten', en: 'Almonds, almond, almond nuts' },
      emoji: '',
      category: 'OK_VERY_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan amandelen aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid. Ze bevatten veel vet en zorg dat ze zoutarm zijn.',
        en: 'Yes, you can give almonds to your cat, but stick to a certain limited amount. Nuts of all types contain a high level of fat. If you do give them, make sure they are unsalted.'
      }
    },
    {
      food: { nl: 'Cashewnoten, cashewnoot, noten, noot', en: 'Cashews, cashew, cashew nuts' },
      emoji: '',
      category: 'OK_VERY_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan cashewnoten aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid. Ze bevatten veel vet en zorg dat ze zoutarm zijn.',
        en: 'Yes, you can give cashews to your cat, but stick to a certain limited amount. Nuts of all types contain a high level of fat. If you do give them, make sure they are unsalted.'
      }
    },
    {
      food: { nl: 'Walnoot, Okkernoot, okkernoten, walnoten, noten, noot', en: 'Walnut, walnuts' },
      emoji: '',
      category: 'OK_VERY_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan walnoot aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid. Let op:  beschimmelde walnoten zijn gevaarlijk. Ze bevatten veel vet en zorg dat ze zoutarm zijn.',
        en: 'Yes, you can give walnut to your cat, but stick to a certain limited amount. Moldy walnuts are highly toxic! Nuts of all types contain a high level of fat. If you do give them, make sure they are unsalted.'
      }
    },
    {
      food: { nl: 'Honing', en: 'Honey' },
      emoji: '🍯',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je kan honing aan je kat geven, maar hou je vast aan een bepaalde maximum hoeveelheid.',
        en: 'Yes, you can give honey to your cat, but stick to a certain limited amount.'
      }
    },
    {
      food: { nl: 'Koffie', en: 'Coffee' },
      emoji: '☕',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen koffie aan je kat geven. Koffie bevat cafeïne.',
        en: 'No, you should not give coffee to your cat. Coffee contains caffeine, which is toxic to cats.'
      }
    },
    {
      food: {
        nl: 'Alcohol, bier, wijn, gin, vodka, wodka, whiskey, champagne, cava',
        en: 'Alcohol, beer, wine, gin, vodka, wodka, whiskey, champagne, cava'
      },
      emoji: '🍷',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen alcohol aan je kat geven.',
        en: 'It goes without saying that no, you should not give alcohol to your cat!'
      }
    },
    {
      food: { nl: 'Thee', en: 'Tea' },
      emoji: '🫖',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen thee aan je kat geven. Thee bevat cafeïne.',
        en: 'No, you should not give tea to your cat. Tea contains caffeine, which is toxic to cats.'
      }
    },
    {
      food: {
        nl: 'Frisdrank, cola, coca cola, fanta, sprite, pepsi, ice-tea',
        en: 'Soda, pop, sugar drink, coca cola, pepsi, sprite, ice-tea, fanta'
      },
      emoji: '🥤',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen frisdrank aan je kat geven. Frisdrank bevat een te hoog suikergehalte.',
        en: 'No, you should not give soda to your cat. Soda contains far too much sugar.'
      }
    },
    {
      food: { nl: 'Snoep, zure snoep, snoepjes, zure beertjes, lolly, lollies', en: 'Candy, gummies, hard candy, gummy bears, lollipops' },
      emoji: '🍬',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen snoep aan je kat geven. Snoep bevat de stof xylitol, die heel toxisch is voor je kat.',
        en: 'No, you should not give candy to your cat. Candy may contain the substance xylitol, which is very toxic to your cat.'
      }
    },
    {
      food: { nl: 'Pindakaas', en: 'Peanut butter' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je mag pindakaas aan je kat geven, maar hou je vast aan bepaalde voorwaarden (zie blog) (enkel natuurlijke pindakaas, zonder xylitol)',
        en: 'Yes, mostly you can give peanut butter to your cat, but only in limited amounts and you must stick to certain conditions. The peanut butter must be unsalted and not contain xylitol.<br /><br />For more details, read further in Cooper Pet Care\'s article <a target="_blank" href="https://cooperpetcare.co">here</a>m/can-cats-eat-peanut-butter/.'
      }
    },
    {
      food: { nl: 'Mayo, Mayonaise', en: 'Mayo, Mayonnaise' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je mag mayo/mayonaise aan je kat geven, maar hou je vast aan bepaalde voorwaarden: zorg dat het geen xylitol bevat (vaak bij lightproducten).',
        en: "Yes, you can give mayonnaise to your cat, but only in limited amounts and you must stick to certain conditions. Make sure it does not contain xylitol - often found in 'Light' products."
      }
    },
    {
      food: { nl: 'Ketchup', en: 'Ketchup' },
      emoji: '',
      category: 'OK_LIMITED_CASES',
      answer: {
        nl: 'Ja, je mag ketchup aan je kat geven, maar hou je vast aan bepaalde voorwaarden: zorg dat het geen xylitol bevat (vaak bij lightproducten).',
        en: "Yes, you can give ketchup to your cat, but only in limited amounts and you must stick to certain conditions. Make sure it does not contain xylitol - often found in 'Light' products."
      }
    },
    {
      food: { nl: 'Mosterd, dijonnaise', en: 'Mustard' },
      emoji: '',
      category: 'NOT_OK',
      answer: {
        nl: 'Nee, je mag geen mosterd aan je kat geven. Het kan zorgen voor ontstekingen in het lichaam.',
        en: 'No, you should not give mustard to your cat! Mustard is a toxic compound for dogs, and can lead to serious gastrointestinal issues.'
      }
    }
  ]
};

export const foodListByPet = (petType, lang) => {
  return foodInfo[petType].reduce((acc, curr) => {
    const foodByLang = curr.food[lang];
    const firstFoodItem = foodByLang.split(', ')[0];
    const filterList = `${foodByLang} ${curr.emoji}`;
    acc = [...acc, { value: firstFoodItem, text: firstFoodItem, filterList }];
    return acc;
  }, []);
};

export const foodCheckerStateByCategory = {
  OK_MOST_CASES: {
    status: 'ok',
    title: {
      en: '👌 Ok in most cases',
      nl: '👌 Prima in de meeste gevallen'
    }
  },
  OK_LIMITED_CASES: {
    status: 'warning',
    title: {
      en: '☝️ Ok in limited amounts',
      nl: '☝️ Alleen oké in beperkte hoeveelheden'
    }
  },
  OK_VERY_LIMITED_CASES: {
    status: 'warning',
    title: {
      en: '🤏 Ok in very limited amounts',
      nl: '🤏 Alleen oké in zeer beperkte hoeveelheden'
    }
  },
  NOT_OK: {
    status: 'danger',
    title: {
      en: '🙅‍♀️ Not ok!',
      nl: '🙅‍♀️ Niet oké!'
    }
  },
  NOT_FOUND: {
    status: 'danger',
    title: {
      en: "Sorry, we couldn't find this food.",
      nl: 'Sorry, dit voedsel konden we niet vinden.'
    }
  }
};
